import React from "react";
import { Image } from "./image";

export const Services = (props) => {
  return (
    <div id="services" className="text-center" style={{ marginTop: "50px" }}>
      <div className="container">
        <div className="section-title">
          <h2>Nos Services</h2>
          <p>
            Découvrez notre gamme de soins de beauté spécialement conçus pour
            vous aider à vous sentir bien dans votre peau. Notre équipe
            d'experts est dédiée à vous offrir des services de qualité qui
            répondent à vos besoins et vous garantissent une expérience
            relaxante et revitalisante.
          </p>
        </div>

        {/* Première ligne avec 3 services */}
        <div className="row" >
          {props.data && props.data.length > 0 ? (
            props.data.slice(0, 3).map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4" style={{marginTop: "100px"}} >
                <Image title={d.name} image={d.image} />
                <div className="service-desc">
                  <a href={`/prestation?name=${d.name}`}>
                    <h3>{d.name}</h3>
                  </a>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </div>

        {/* Deuxième ligne avec 1 service */}
        <div className="row">
          {props.data && props.data.length > 3 ? (
            <div className="col-md-12" style={{marginTop: "100px" }}>
              <Image
                title={props.data[3].name}
                image={props.data[3].image}
                style={{ width: "100%", height: "auto" }} // Assurez-vous que l'image prend toute la largeur
              />
              <div className="service-desc">
                <a href={`/prestation?name=${props.data[3].name}`}>
                  <h3>{props.data[3].name}</h3>
                </a>
                <p>{props.data[3].text}</p>
              </div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </div>

        {/* Troisième ligne avec 3 services */}
        <div className="row" >
          {props.data && props.data.length > 4 ? (
            props.data.slice(4, 7).map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4" style={{marginTop: "100px" }}>
                <Image title={d.name} image={d.image} />
                <div className="service-desc">
                  <a href={`/prestation?name=${d.name}`}>
                    <h3>{d.name}</h3>
                  </a>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};
